export default "__VITE_ASSET__B1W8PEl___"